export const galleryProjects = [
  {
    id: 'driveway',
    title: { en: 'Concrete Driveway', es: 'Entrada de Concreto' },
    description: { en: 'Complete driveway replacement - Chicago, IL', es: 'Reemplazo completo de entrada - Chicago, IL' },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/12fb526c-e133-419e-8b1b-b60dad33ed66.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/6fba2d70-e265-4bb4-a2b9-4e4987a52268.jpg',
  },
  {
    id: 'lot-resurfacing',
    title: { en: 'Asphalt Resurfacing', es: 'Repavimentación de Asfalto' },
    description: { en: 'Parking lot resurfacing - Oak Park, IL', es: 'Repavimentación de estacionamiento - Oak Park, IL' },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/f419db80-f1ef-4b4b-8851-7ad79640deb9.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/0fa61965-eb20-4d94-bc78-b701a3b3d27a.jpg',
  },
  {
    id: 'foundation',
    title: { en: 'Concrete Foundation', es: 'Cimentación de Concreto' },
    description: { en: 'Commercial foundation work - Evanston, IL', es: 'Trabajo de cimentación comercial - Evanston, IL' },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/d1240408-a0ea-4cfc-b62f-8388253f0c5b.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/1b25e2f0-656c-4472-8ec5-f8f3b31f3e2e.jpg',
  },
];

export type GalleryProject = (typeof galleryProjects)[number];
